import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import "../src/assets/scss/styles.scss";
import ReactGA from "react-ga4";
import { FoundryProvider } from "foundry";
// import MobileScreenBlocker from "./MobileScreenBlocker";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({});
const TRACKING_ID = process.env.REACT_APP_GOOGLE_TRACKING_ID || "";
ReactGA.initialize(TRACKING_ID);
ReactGA.send({
  hitType: "pageview",
  page: window.location.pathname,
});

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    {/* <MobileScreenBlocker> */}
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <FoundryProvider
            supportedConnectors={[
              "MetaMask",
              "AlgoSigner",
              "Keplr",
              "WalletConnect",
              "Zerion",
            ]}
            AlgoSignerLedger="TestNet"
          >
            <App />
          </FoundryProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
    {/* </MobileScreenBlocker> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
